import { QUARTERLY_DETAILS, TABLE_HEADER_SUBTEXT } from '@constants/commonConstants';
import { DateSorting, DateFiltering, OppsNameSorting } from '@util/commonFunctions';

const CommitStatusFilter = params => {
  if (params.data && params.data.commit_status !== undefined) {
    if (params.data.commit_status === 0) {
      return QUARTERLY_DETAILS.NOT_COMMITTED;
    } else if (params.data.commit_status === 1) {
      return QUARTERLY_DETAILS.COMMITTED;
    } else {
      return '';
    }
  }
};

export const columnDefs = [
  {
    headerName: 'Commit',
    field: 'commit_status',
    cellRenderer: 'commitCellRenderer',
    filter: 'agTextColumnFilter',
    filterValueGetter: CommitStatusFilter,
    sortable: false,
    suppressMovable: true,
    width: 130,
  },
  {
    headerName: 'Status',
    field: 'tag',
    cellRenderer: 'statusCellRenderer',
    filter: 'agTextColumnFilter',
    sortable: true,
    suppressMovable: true,
    width: 135,
  },
  {
    headerName: 'ID',
    field: 'ey_id',
    cellRenderer: 'textCellRendererCBold',
    filter: 'agTextColumnFilter',
    sortable: true,
    suppressMovable: true,
    width: 105,
  },
  {
    field: 'pursuit_type',
    headerName: 'Pursuit Type',
    cellRenderer: 'pursuitTypeCellRenderer',
    filter: 'agTextColumnFilter',
    sortable: true,
    suppressMovable: true,
    width: 170,
  },
  {
    headerName: 'Opportunity Name',
    field: 'opportunity_name',
    cellRenderer: 'textCellRendererCBold',
    comparator: OppsNameSorting,
    filter: 'agTextColumnFilter',
    sortable: true,
    suppressMovable: true,
    width: 210,
  },
  {
    headerName: 'Client',
    field: 'client_name',
    cellRenderer: 'textCellRendererC',
    filter: 'agTextColumnFilter',
    sortable: true,
    suppressMovable: true,
    width: 200,
  },
  {
    headerName: 'Eff. Close Date',
    field: 'close_date',
    cellRenderer: 'dateCellRenderer',
    cellRendererParams: params => {
      const month = params.data.ecd_month;
      const date = params.data.close_date;
      return { month, date };
    },
    comparator: DateSorting,
    filter: 'agDateColumnFilter',
    filterParams: DateFiltering,
    headerComponentParams: {
      subText: TABLE_HEADER_SUBTEXT.DATE_FISCAL_MONTH,
    },
    sortable: true,
    suppressMovable: true,
    width: 185,
  },
  {
    headerName: 'AWD',
    field: 'awd',
    cellRenderer: 'dateCellRenderer',
    cellRendererParams: params => {
      const month = params.data.awd_month;
      const date = params.data.awd;
      return { month, date };
    },
    comparator: DateSorting,
    filter: 'agDateColumnFilter',
    filterParams: DateFiltering,
    headerComponentParams: {
      subText: TABLE_HEADER_SUBTEXT.DATE_FISCAL_MONTH,
    },
    sortable: true,
    suppressMovable: true,
    width: 175,
  },
  {
    headerName: 'TOV ($)',
    field: 'commit_tov',
    cellClass: 'cell-text-aligment',
    cellRenderer: 'textCellRendererD',
    cellRendererParams: params => {
      const commit_tov = params.data.commit_tov;
      const sold_tov = params.data.sold_tov_eop;
      const tag = params.data.tag;
      return { commit_tov, sold_tov, tag };
    },
    filter: 'agTextColumnFilter',
    headerComponentParams: {
      subText: TABLE_HEADER_SUBTEXT.ACTUAL_FORECASTED,
    },
    sortable: true,
    suppressMovable: true,
    width: 220,
  },
  {
    headerName: 'Stage',
    field: 'stage_name',
    cellRenderer: 'textCellRendererC',
    filter: 'agTextColumnFilter',
    sortable: false,
    suppressMovable: true,
    width: 130,
  },
  {
    headerName: 'Account',
    field: 'account_name',
    cellRenderer: 'textCellRendererC',
    filter: 'agTextColumnFilter',
    sortable: true,
    suppressMovable: true,
    width: 200,
  },
];
